import type { FunctionComponent } from 'react'
import React from 'react'
import { useParams } from 'react-router-dom'
import type { LinkType } from '@which/seatbelt'
import { Grid, GridItem, MultiLinkCard } from '@which/seatbelt'
import { createSlugGenerator } from '@which/shared'

import type { ImageWithSources } from '../../../generated/frontend'
import type { PageParams } from '../../../routes'
import { extractContentIdFromUrl, shouldAddTracking } from '../../utils/get-tracking-info'
import styles from './MultiLinkBlocks.module.scss'

export const MultiLinkBlocks: FunctionComponent<Props> = ({ hubMultiLinks }) => {
  const { subVerticalSlug } = useParams<PageParams>()

  if (!hubMultiLinks.length) {
    return null
  }

  const isAddTracking = shouldAddTracking(subVerticalSlug)

  const hubMultiLinksWithTracking: HubMultiLink[] = hubMultiLinks.map((hubMultiLink) => ({
    ...hubMultiLink,
    links: (hubMultiLink.links ?? []).map((link, index) => ({
      ...link,
      ...(isAddTracking && {
        'data-which-id': `${subVerticalSlug} link`,
        'data-section': hubMultiLink.title,
        'data-index': String(index + 1),
        'data-card-name': link.text,
        'data-content-id': extractContentIdFromUrl(link.href),
      }),
    })),
  }))

  const createSlug = createSlugGenerator()

  return (
    <Grid className="w-page-wrapper">
      <GridItem span={{ medium: 10, large: 10 }} columnStart={{ medium: 2, large: 2 }}>
        <div className={styles.multiLinkBlocksGrid} data-testid="multi-link-blocks">
          {hubMultiLinksWithTracking.map((hubMultiLink) => {
            return (
              <MultiLinkCard
                {...hubMultiLink}
                id={createSlug(hubMultiLink.title)}
                key={hubMultiLink.title}
                className={styles.card}
              />
            )
          })}
        </div>
      </GridItem>
    </Grid>
  )
}

///////// IMPLEMENTATION /////////

export type HubMultiLink = {
  title: string
  links: LinkType[]
  image: string
  imageSources: ImageWithSources['sources']
  imageAlt: ImageWithSources['alt']
}

type Props = {
  hubMultiLinks: HubMultiLink[]
}
